import parseHTML from "../dom/funciones/parse_html";
import SwipeIt from '../swipe-it';
var columnas = function () {
    [].forEach.call(document.querySelectorAll('.columna-imagenes > .inner'), function (contenedor) {
        var imagenes = Array.from(contenedor.querySelectorAll('.columna-imagenes-imagen'));
        var actual = 0;
        if (imagenes.length > 1) {
            var navegacion_1 = parseHTML('<div class="columna-navegacion"></div>'), contador_1 = parseHTML('<div class="columna-contador"></div>'), maximo_1 = imagenes.length, actualiza_1 = function (posicion) {
                actual = Math.max(0, Math.min(posicion, maximo_1 - 1));
                imagenes.forEach(function (imagen) { return imagen.style.transform = "translateX(-".concat(actual * 100, "%)"); });
                contador_1.innerHTML = imagenes.map(function (imagen, i) {
                    if (i === actual) {
                        return "<span class=\"actual\"><button data-posicion=\"".concat(i, "\">").concat(i + 1, "</button></span>");
                    }
                    else {
                        return "<span><button data-posicion=\"".concat(i, "\">").concat(i + 1, "</button></span>");
                    }
                }).join('');
            };
            contenedor.parentElement.appendChild(navegacion_1);
            navegacion_1.appendChild(contador_1);
            navegacion_1.addEventListener('click', function (e) {
                var boton = e.target.closest('button[data-posicion]');
                if (boton) {
                    actualiza_1(parseInt(boton.getAttribute('data-posicion'), 10));
                }
            });
            var swipeIt = new SwipeIt(contenedor.parentElement);
            swipeIt.on('swipeLeft', function () { return actualiza_1(actual + 1); });
            swipeIt.on('swipeRight', function () { return actualiza_1(actual - 1); });
            actualiza_1(0);
        }
    });
};
export default columnas;
